import { trackEvent, trackEventGA4 } from '../gtm';
import { BannerLocationType } from '../../components/dwh-tracking/types';

export interface TrackBannerParams {
    type: 'IMG' | 'VIDEO' | 'SNACKBAR' | 'VIDEO_BANNER-URL' | 'VIDEO_BANNER-REGISTRATION' | 'VIDEO_BANNER-LIVE';
    id: number;
    visibility: 'ALL' | 'ANONYMOUS' | 'LOGGED';
    index: number;
    location: BannerLocationType;
    url: string;
    text: string;
}
export const trackBannerClick = ({
    type = 'IMG',
    id,
    visibility = 'ALL',
    location,
    index,
    url,
    text
}: TrackBannerParams) => {
    trackEvent('banner_click', location, [id, type, location, visibility, index, text, url].join(','));
    trackEventGA4('banner_click', { type, id, visibility, location, index, url, text });
};

export const trackBannerShow = ({
    type = 'IMG',
    id,
    visibility = 'ALL',
    location,
    index,
    url,
    text
}: TrackBannerParams) => {
    trackEvent('banner_show', location, [id, type, location, visibility, index, text, url].join(','));
    trackEventGA4('banner_show', { type, id, visibility, location, index, url, text });
};
